import axios from "axios";
import { API } from "@/lib/api";

const KEY = "aor_student_token";
export const studentToken = () => localStorage.getItem(KEY);
export const setStudentToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
const h = () => ({ Authorization: `Bearer ${studentToken() || ""}` });

export const learn = {
  me: () => axios.get(`${API}/learn/me`, { headers: h() }).then((r) => r.data),
  course: (c) => axios.get(`${API}/learn/course/${c}`, { headers: h() }).then((r) => r.data),
  progress: (session_id, done) => axios.post(`${API}/learn/progress`, { session_id, done }, { headers: h() }),
  submit: (form) => axios.post(`${API}/learn/submit`, form, { headers: h() }).then((r) => r.data),
  file: async (fid) => {
    const r = await axios.get(`${API}/learn/files/${fid}`, { headers: h(), responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  },
  viewInfo: (fid) => axios.get(`${API}/learn/view/${fid}`, { headers: h() }).then((r) => r.data),
  viewPage: (fid, i) => axios.get(`${API}/learn/view/${fid}/page/${i}`, { headers: h(), responseType: "blob" }).then((r) => URL.createObjectURL(r.data)),
  certificate: async (course) => {
    const r = await axios.get(`${API}/learn/certificate/${course}`, { headers: h(), responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = `ArtOfResume-certificate-${course}.pdf`;
    a.click();
    URL.revokeObjectURL(a.href);
  },
};

export const sessionState = (s) => {
  if (!s?.starts_at) return "unscheduled";
  const start = new Date(s.starts_at).getTime();
  const end = start + (s.duration_min || 90) * 60000;
  const now = Date.now();
  if (now >= start - 15 * 60000 && now <= end) return "live";
  return now < start ? "upcoming" : "completed";
};

export const isPdf = (r) => Boolean(r?.file_id) && /\.pdf$/i.test(r.filename || "");
